export default "<p>dchatfriendbuttons works!</p>\n";